export const RECEIVE_COLLEGE_SUCCESS_ITEMS = 'RECEIVE_COLLEGE_SUCCESS_ITEMS';
export const RECEIVE_COLLEGE_SUCCESS_ITEM = 'RECEIVE_COLLEGE_SUCCESS_ITEM';
export const EDIT_COLLEGE_SUCCESS_ITEM = 'EDIT_COLLEGE_SUCCESS_ITEM';
export const REMOVE_COLLEGE_SUCCESS_ITEM = 'REMOVE_COLLEGE_SUCCESS_ITEM';
